import styled from "styled-components";
import { VisuallyHide } from "storybook/styles/common";
import { Typography } from "storybook/components/typography";
import { defaultTheme } from "storybook/themes/default";

const { colors } = defaultTheme;

type StyledCheckboxLabelDefaultProps = {
  $hasError: boolean;
  $isDirty: boolean;
  $disabled: boolean;
  $readOnly: boolean;
  $button: boolean;
  $checked: boolean;
  $keyboardFocus: boolean;
  $alignTop: boolean;
  $size: "small" | "medium";
};

export const StyledCheckboxLabelDefault = styled(Typography).attrs(
  ({ $hasError, $isDirty }: StyledCheckboxLabelDefaultProps) => ({
    color: $hasError ? "error" : $isDirty ? "dirtyLabel" : "black",
    theme: "default",
    variant: "body1",
    component: "label",
  })
)`
  flex: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin: 0 16px 0 -11px;

  > input {
    ${VisuallyHide}
  }

  > svg {
    flex-shrink: 0;
    position: relative;
    box-sizing: content-box; // border-box collapses the svg
    color: ${({ $hasError, $isDirty }: StyledCheckboxLabelDefaultProps) =>
      $hasError
        ? colors.error
        : $isDirty
        ? colors.dirtyLabel
        : colors.ciqBrandLight};
    background-color: ${({ $keyboardFocus }) =>
      $keyboardFocus ? colors.inputBorder : "transparent"};
    transform: scale(${({ $size }) => ($size === "small" ? "0.7" : "1")});
    padding: ${({ $size }) => ($size === "small" ? "2px 9px 2px 2px" : "9px")};

    ${({ $alignTop }) =>
      $alignTop &&
      `
        align-self: flex-start;
        margin-top: -6px;
      `}
  }

  ${({ $disabled, $readOnly }) =>
    $disabled || $readOnly
      ? `
    cursor: default;
    pointer-events: none;
    opacity: 0.7;

  `
      : `
    > svg:hover {
      border-radius: 5px;
    }
  `};

  ${({ $button, $size }) =>
    $button
      ? `
      flex: none;
      display: inline-block;
      border-radius: 22px;
      text-align: center;
      color: ${colors.hematite};
      background-color: ${colors.white};
      padding: ${$size === "small" ? "4px 20px" : "7px 30px"};
      box-shadow: inset 0px 0px 0px 1px ${colors.greyDark};
      `
      : ``};

  ${({ $checked, $button }) =>
    $checked && $button
      ? `
      box-shadow: inset 0px 0px 0px 3px #B9680F;
      background-color: #FFECD7;
    `
      : ``};
`;
